<template>
	<div>
		<span v-if="version" class="text-body-2 font-weight-light">{{ version.version }}</span>
		<v-progress-circular v-if="loading" indeterminate color="primary" :size="20"></v-progress-circular>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
	computed: {
		...mapState({
			loading: state => state.status.loading,
			version: state => state.status.version,
		}),
	},
	methods: {
		...mapActions({
			load: 'status/load',
		}),
	},
	beforeMount: function() {
		this.load();
	},
};
</script>
